import debounce from "lodash/debounce";
import { FC, MouseEventHandler, useState } from "react";
import { Image } from "@/components/Image/Image";

interface Props {
  onClick: MouseEventHandler<HTMLImageElement>;
  tooltip: string;
}

export const CopyButton: FC<Props> = ({ onClick, tooltip }) => {
  const [showMessage, setShowMessage] = useState(false);

  const hideMessage = debounce(() => setShowMessage(false), 1500);

  return (
    <div className="absolute right-[12px] top-[12px] cursor-pointer text-[#f0f8ff]">
      {showMessage && (
        <div className="bottom-[calc(100%+8px] absolute right-0 w-max rounded-[4px] border border-solid border-black bg-black px-[4px] py-0 text-[12px] font-normal shadow-[5px_-4px_5px_-5px_#00000066]">
          {tooltip}
        </div>
      )}
      <Image
        onClick={(e) => {
          setShowMessage(true);
          hideMessage();
          onClick(e);
        }}
        src="/images/copy.svg"
        width={16}
        height={16}
        alt="Copy button"
        className="!m-0 h-[16px] w-[16px] active:opacity-50"
      />
    </div>
  );
};
